<div class="wrap">
    <div class="logoWrapper">


        <!-- <img src="/assets/icons/cph-logo-b.png" alt="Logo CPH bleu"> -->
    </div>
    <div class="ForgotPassword">
        <p>Reset password</p>
        <form [formGroup]="ForgotFormForm" (ngSubmit)="onSubmit()">
            <div class="formField">

                <mat-form-field appearance="outline">
                    <mat-label>
                        Username
                    </mat-label>
                    <input type="text" matInput formControlName="username">

                </mat-form-field>
            </div>


            <button type="submit" mat-raised-button color="primary" *ngIf="!isLoading">Send mail</button>
            <mat-spinner *ngIf="isLoading" [diameter]="35" color="primary"></mat-spinner>
        </form>
    </div>
